import { get } from './get';

export const suggestedEdit = {
  get,
};
